import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import './search.css';
import { Toast } from '../components_root/ToastContext';
import { MdClose, MdLocationCity, MdManageSearch, MdSearch } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
export const seo = {
    title: "Search Tools | aooz Free & Premium Online Utilities for Productivity & SEO",
    description: "Explore aooz Search to quickly find free and premium online tools. Access file converters, SEO analyzers, word counters, favicon generators, and productivity utilities in one place.",
    keywords: "aooz search, online search tools, find tools, productivity search, free seo tools, file converters, text utilities, image to pdf, favicon generator, word counter, premium tools",
    url: "https://aooz.in/search",
    image: "https://aooz.in/assets/logo.png"
};
export default function Search_root() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [searchqry, setsearchqry] = useState();

    const search_qry = () => {
        if (!searchqry || searchqry.trim() === "") {
            Toastshow("Enter search");
            return;
        }
        Toastshow(searchqry);
        // continue search logic here
    };
    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="b-1 rounded-30 m-2">
                <table>
                    <tr>



                        <td>
                            <input
                                value={searchqry}   // ✅ state value
                                onChange={(e) => setsearchqry(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        search_qry();
                                    }
                                }}
                                className="p-2 rounded-30 border-none text-h1"
                                placeholder="Search"
                            />
                        </td>




                        <td className="cursor b-left p-22" width={40}><CiSearch onClick={() => search_qry()} className="icon" /></td>
                    </tr>
                </table>
            </div>
            <div className="container_roots">
                Search_root
            </div>

        </div>
    );
}
